import create from "zustand";
import { PublicKey } from "@solana/web3.js";
import { RestrictionOptionsMap } from "../common/constants/civic.constants";
import { RestrictionLocationOptions } from "../common/enums/civic.enum";

interface ISolanaGatewayToken {
  issuingGatekeeper: PublicKey;
  gatekeeperNetworkAddress: PublicKey;
  owner: PublicKey;
  state: string;
  publicKey: PublicKey;
  expiryTime?: number;
}
interface IGatewayData {
  gatewayToken: ISolanaGatewayToken | undefined;
  gatekeeperNetwork: PublicKey;
}

interface IGatewayStore extends IGatewayData {
  setGatewayToken: (gatewayToken: ISolanaGatewayToken) => void;
  setGatekeeperNetwork: (gatekeeperNetwork: PublicKey) => void;
}

const initialState: IGatewayData = {
  gatewayToken: undefined,
  gatekeeperNetwork:
    RestrictionOptionsMap[RestrictionLocationOptions.AllCountries]
      .gatekeeperNetwork,
};

export const gatewayStore = create<IGatewayStore>((set) => ({
  ...initialState,
  setGatewayToken: (gatewayToken: ISolanaGatewayToken) =>
    set(() => ({ gatewayToken })),
  setGatekeeperNetwork: (gatekeeperNetwork: PublicKey) =>
    set(() => ({ gatekeeperNetwork })),
}));
